import type { ReactNode } from "react";

export type HeaderProps = { title: ReactNode; className?: string };

export function Header({ title, className }: HeaderProps) {
  return (
    <div
      className={[
        `text-2xl text-persian-plum-900 text-center border-b border-antique-brass-500 pb-6 w-full`,
        className,
      ].join(" ")}
      data-type={"header"}
    >
      {title}
    </div>
  );
}
